// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inquiries-container .message-reply-modal {
  opacity: 0;
  visibility: hidden;
  height: 100vh;
  width: 100vw;
  transition: 0.3s ease-in-out;
  position: fixed;
  background-color: rgba(255, 255, 255, 0.85);
  top: 0;
  left: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.inquiries-container .message-reply-modal.visible {
  opacity: 1;
  visibility: visible;
}
.inquiries-container .message-reply-modal .form-section {
  width: 500px !important;
  background: #FFFFFF;
  box-shadow: 0px 4px 20px rgba(53, 99, 55, 0.2);
  border-radius: 10px;
  padding: 50px 70px;
  display: flex;
  flex-direction: column;
}
.inquiries-container .message-reply-modal .form-section .section-title {
  margin: 0;
  font-weight: 700;
  font-size: 20px;
  color: var(--secondary-color-1);
}
.inquiries-container .message-reply-modal .form-section .section-title.message {
  font-size: 16px;
  font-weight: 600;
  color: #6C767C;
  line-height: 24px;
}
.inquiries-container .message-reply-modal .form-section .form-input > label {
  font-size: 14px;
  font-weight: 600;
  color: var(--secondary-color-5);
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}
.inquiries-container .message-reply-modal .form-section > button {
  height: 45px;
  font-size: 16px;
}
.inquiries-container .message-reply-modal .form-section > button.cancel {
  background: var(--secondary-color-4);
  color: var(--secondary-color-3);
}
.inquiries-container .message-reply-modal .form-section > button.cancel:hover {
  opacity: 0.75;
}
.inquiries-container .message-reply-modal .form-section > button.delete {
  background: rgb(235, 74, 74);
  color: white;
}
.inquiries-container .message-reply-modal .form-section > button.delete:hover {
  opacity: 0.75;
}`, "",{"version":3,"sources":["webpack://./src/routes/AgentDashboard/modules/Inquiries/modules/MessageReplyModal/messageReplyModal.scss"],"names":[],"mappings":"AACI;EACI,UAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,4BAAA;EACA,eAAA;EACA,2CAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAR;AACQ;EACI,UAAA;EACA,mBAAA;AACZ;AACQ;EACI,uBAAA;EACA,mBAAA;EACA,8CAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AACZ;AAAY;EACI,SAAA;EACA,gBAAA;EACA,eAAA;EACA,+BAAA;AAEhB;AADgB;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAGpB;AACgB;EACI,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AACpB;AAEY;EACI,YAAA;EACA,eAAA;AAAhB;AACgB;EACI,oCAAA;EACA,+BAAA;AACpB;AAAoB;EAAU,aAAA;AAG9B;AADgB;EACI,4BAAA;EACA,YAAA;AAGpB;AAFoB;EAAU,aAAA;AAK9B","sourcesContent":[".inquiries-container {\n    .message-reply-modal {\n        opacity: 0;\n        visibility: hidden;\n        height: 100vh;\n        width: 100vw;\n        transition: .3s ease-in-out;\n        position: fixed;\n        background-color: rgba($color: white, $alpha: .85);\n        top: 0;\n        left: 0;\n        z-index: 999;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        &.visible {\n            opacity: 1;\n            visibility: visible;\n        }\n        .form-section {\n            width: 500px !important;\n            background: #FFFFFF;\n            box-shadow: 0px 4px 20px rgba(53, 99, 55, 0.2);\n            border-radius: 10px;\n            padding: 50px 70px;\n            display: flex;\n            flex-direction: column;\n            .section-title {\n                margin: 0;\n                font-weight: 700;\n                font-size: 20px;\n                color: var(--secondary-color-1);\n                &.message {\n                    font-size: 16px;\n                    font-weight: 600;\n                    color: #6C767C;\n                    line-height: 24px;\n                }\n            }\n            .form-input {\n                > label {\n                    font-size: 14px;\n                    font-weight: 600;\n                    color: var(--secondary-color-5);\n                    display: flex;\n                    align-items: center;\n                    margin-bottom: 5px;\n                }\n            }\n            > button {\n                height: 45px;\n                font-size: 16px;\n                &.cancel {\n                    background: var(--secondary-color-4);\n                    color: var(--secondary-color-3);\n                    &:hover { opacity: .75; }\n                }\n                &.delete {\n                    background: rgb(235, 74, 74);\n                    color: white;\n                    &:hover { opacity: .75; }\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
